module.exports = __webpack_public_path__ + "f5c22d15f133f5c0955828d802ce909f.png";